// extracted by mini-css-extract-plugin
module.exports = {"root":"MainMenuUL_root__2ziC-"};